import { c as _c } from "react/compiler-runtime";
import { Mail, Send, Wallet } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { partner } from "@/mocks/residual";
export function AuthPage(t0) {
  const $ = _c(33);
  const {
    onAuthed
  } = t0;
  const [mode, setMode] = useState("signin");
  const [email, setEmail] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-8 text-center"><div className="mx-auto mb-3 grid size-12 place-items-center rounded-2xl bg-foreground text-background text-xl font-semibold">{partner.name[0]}</div><h1 className="text-xl font-semibold">{partner.name}</h1><p className="text-xs text-muted-foreground">Powered by Residual</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["signin", "signup"];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== mode) {
    t3 = <div className="grid grid-cols-2 gap-1 rounded-lg bg-muted p-1">{(t2 as const).map(m => <button key={m} type="button" onClick={() => setMode(m)} className={`rounded-md py-1.5 text-sm font-medium transition-colors ${mode === m ? "bg-background shadow-sm" : "text-muted-foreground"}`}>{m === "signin" ? "Sign in" : "Create account"}</button>)}</div>;
    $[2] = mode;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onAuthed) {
    t4 = e => {
      e.preventDefault();
      onAuthed();
    };
    $[4] = onAuthed;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Label htmlFor="email">Email</Label>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e_0 => setEmail(e_0.target.value);
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== email) {
    t7 = <div className="space-y-2">{t5}<Input id="email" type="email" required={true} placeholder="you@example.com" value={email} onChange={t6} /></div>;
    $[8] = email;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Mail className="size-4" />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = mode === "signin" ? "Continue with email" : "Create account";
  let t10;
  if ($[11] !== t9) {
    t10 = <Button type="submit" className="w-full gap-2">{t8}{t9}</Button>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t4 || $[15] !== t7) {
    t11 = <form onSubmit={t4} className="space-y-3">{t7}{t10}</form>;
    $[13] = t10;
    $[14] = t4;
    $[15] = t7;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Separator className="flex-1" />;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="flex items-center gap-3 text-[11px] uppercase tracking-wide text-muted-foreground">{t12} or <Separator className="flex-1" /></div>;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Send className="size-4" />;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== onAuthed) {
    t15 = <Button variant="outline" className="w-full gap-2" onClick={onAuthed}>{t14} Continue with Telegram</Button>;
    $[20] = onAuthed;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Wallet className="size-4" />;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== onAuthed) {
    t17 = <Button variant="outline" className="w-full gap-2" onClick={onAuthed}>{t16} Connect wallet</Button>;
    $[23] = onAuthed;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t15 || $[26] !== t17) {
    t18 = <div className="grid gap-2">{t15}{t17}</div>;
    $[25] = t15;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <p className="text-center text-[11px] text-muted-foreground">By continuing you agree to {partner.name}'s terms and Residual's privacy policy.</p>;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t11 || $[30] !== t18 || $[31] !== t3) {
    t20 = <div className="mx-auto flex min-h-dvh max-w-md flex-col justify-center px-6 py-10">{t1}<Card><CardContent className="space-y-5 pt-6">{t3}{t11}{t13}{t18}{t19}</CardContent></Card></div>;
    $[29] = t11;
    $[30] = t18;
    $[31] = t3;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  return t20;
}